/* eslint-disable import/no-anonymous-default-export */
import toNumber from 'lodash/toNumber'
import decimalDigit from "./decimalDigit"

// Addons 2024-05-19
const host_divk = process.env.REACT_APP_DIVISION_K || ''

export default ({
  divisionlogin='E',
  boxQty= 0,
  unitQty=0,
  unitPrice=0,
  packingSize=0
}) => {
  console.log(`2024-05-19 :: calculateSaleWithoutDisc.js ==> divisionlogin ==> `,divisionlogin)
  console.log(`2024-05-19 :: calculateSaleWithoutDisc.js ==> host_divk ==> `,host_divk)

  let salePrice = 0.00 
  if(divisionlogin === host_divk){
    console.log(`2024-05-19 :: calculateSaleWithoutDisc in case div.K`)

    // const pricePerUnit = toNumber(unitPrice) / toNumber(packingSize)
    let pricePerUnit = toNumber(unitPrice) / toNumber(packingSize)
        // earn --
        pricePerUnit = Math.round(10000 * parseFloat(pricePerUnit))/10000
        console.log(`: pricePerUnit : `, pricePerUnit)
        // -------

    // const pricePerBox = toNumber(boxQty) * toNumber(unitPrice)
    let pricePerBox = toNumber(boxQty) * toNumber(unitPrice)
        // earn --
        pricePerBox = Math.round(10000 * parseFloat(pricePerBox))/10000
        console.log(`: pricePerBox : `, pricePerBox)
        // -------

    const pricePerItem = toNumber(unitQty) * toNumber(pricePerUnit)

    // const salePrice = toNumber(pricePerBox) + toNumber(pricePerItem)
    salePrice = toNumber(pricePerBox) + toNumber(pricePerItem)
        // earn --
        console.log(`calculateSaleWithoutDisc.js salePrice Brfore ==> `,salePrice)
        salePrice = Math.round(10000 * parseFloat(salePrice))/10000
        console.log(`calculateSaleWithoutDisc.js salePrice After ==> `,salePrice)
        // -------
  }else{
    console.log(`2024-05-19 :: calculateSaleWithoutDisc in case div.E`)
    const pricePerUnit = toNumber(unitPrice) / toNumber(packingSize)
    const pricePerBox = toNumber(boxQty) * toNumber(unitPrice)
    const pricePerItem = toNumber(unitQty) * toNumber(pricePerUnit)
    salePrice = toNumber(pricePerBox) + toNumber(pricePerItem)
  }

  return decimalDigit({ divisionlogin: divisionlogin, amount: salePrice, digit: 2 })
}